import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMegaComponent } from './simple-icons-mega.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMegaComponent ],
    exports:      [ SimpleIconsMegaComponent ],
    bootstrap:    []
})
export class SimpleIconsMegaModule {}
